import { render, staticRenderFns } from "./CartSidebar.vue?vue&type=template&id=3a2366fc&scoped=true&"
import script from "./CartSidebar.vue?vue&type=script&lang=js&"
export * from "./CartSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CartSidebar.vue?vue&type=style&index=0&id=3a2366fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2366fc",
  null
  
)

export default component.exports